import template from './progress-bar.html';
import controller from './progress-bar.controller';

let ProgressBarComponent = {
    restrict: 'E',
    bindings: {
        current: '<',      // Current value
        total: '<',         // Total/target value
        height: '@',       // Height of the bar (default: 20)
        color: '@',        // Progress color (default: #27ae60)
        bgColor: '@',      // Background color (default: #e0e0e0)
        showPercentage: '<', // Show percentage text (default: true)
        showValues: '<',    // Show current/total values (default: false)
        animated: '<',     // Animate progress (default: true)
        striped: '<'       // Show striped pattern (default: false)
    },
    template,
    controller
}

export default ProgressBarComponent;




// WEBPACK FOOTER //
// ./client/common/directives/progress-bar/progress-bar.component.js